import React from 'react';

import { IButtonImageV3 } from '../../../../interfaces/button';
import { GenericFunction } from '../../../../types/genericTypes';
import BdsLabelPill from '../../BdsLabelPill/BdsLabelPill';
import TruncatedText from '../../Table/StyledColumns/TruncatedText/TruncatedText';

import './GenericCard.scss';

interface IGenericCard {
  title: string;
  description?: string;
  tag?: string;
  icon?: string;
  iconButton?: IButtonImageV3;
  size?: 's' | 'm' | 'l';
  truncatedText?: boolean;
  action?: GenericFunction;
  className?: string;
  customTag?: React.ReactNode;
}

const GenericCard = ({
  title,
  description,
  tag,
  icon,
  iconButton,
  size = 's',
  truncatedText,
  action,
  className = '',
  customTag
}: IGenericCard) => {
  const handleClick = (e: React.MouseEvent) => {
    if (action) {
      e.stopPropagation();
      action();
    }
  };

  return (
    <button
      data-experience="new"
      className={`generic-card-container flex flex-col gap-4 p-6 ${size} ${className} ${action ? 'gc-action' : ''}`}
      onClick={handleClick}
    >
      {tag && <BdsLabelPill text={tag} variant="accent" color="accent-quaternary" />}
      {(icon || iconButton) && (
        <div className="flex flex-row justify-between" data-experience="new">
          {icon && <img className="gc-icon" src={icon} alt="icon" />}
          {iconButton && <iconButton.component className="gc-icon-button" />}
        </div>
      )}
      <div className="flex flex-col gap-2 w-full text-left">
        <div className="gc-title">
          {truncatedText ? <TruncatedText text={title} lines={1} maxWidth={'308px'} /> : title}
        </div>
        <div className="gc-description">{description}</div>
      </div>
      {customTag || null}
    </button>
  );
};

export default GenericCard;
